import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const General = (props: SvgProps) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      rx="7.75"
      fill="#F8FAFC"
    />
    <rect
      x="0.25"
      y="0.25"
      width="31.5"
      height="31.5"
      rx="7.75"
      stroke="#CBD5E1"
      strokeWidth="0.5"
    />
    <g clipPath="url(#clip0_8_4442)">
      <path
        d="M22.6663 16C22.6663 19.6819 19.6816 22.6666 15.9997 22.6666M22.6663 16C22.6663 12.3181 19.6816 9.33331 15.9997 9.33331M22.6663 16H9.33301M15.9997 22.6666C12.3178 22.6666 9.33301 19.6819 9.33301 16M15.9997 22.6666C14.2878 20.8692 13.333 18.4822 13.333 16C13.333 13.5178 14.2878 11.1307 15.9997 9.33331M15.9997 22.6666C17.7115 20.8692 18.6663 18.4822 18.6663 16C18.6663 13.5178 17.7115 11.1307 15.9997 9.33331M9.33301 16C9.33301 12.3181 12.3178 9.33331 15.9997 9.33331"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_4442">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </Svg>
);

export default General;
